import styled from "styled-components";

export const ContainerErrorPage = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center; 
    align-items: center;      
    gap: 50px;
    height: 70vh;            
    max-width: 1170px;
    margin: 0 auto;

    @media (max-width: 1024px) {
        gap: 10px;
        flex-direction: column;
        align-items: center;
    }
`;